<mat-form-field appearance="outline">
  <mat-label>{{ label ?? name }}</mat-label>
  <mat-date-range-input [rangePicker]="datePicker">
    <input matStartDate [formControlName]="startRangeName" />
    <input matEndDate [formControlName]="endRangeName" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-date-range-picker #datePicker></mat-date-range-picker>
  @if (description) {
    <mat-hint>
      <mat-icon>info</mat-icon>
      {{ description }}
    </mat-hint>
  }
</mat-form-field>
